import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import banner from '../../assets/banner.jpg';
import { getDeviceType } from '../../utils/common';
import { pageAction } from '../../redux_files/actions/page_actions';

const HomeCookedFood = () => {
	const dispatch = useDispatch();
	const [deviceType, setDeviceType] = useState(getDeviceType());
	useEffect(() => {
		window.addEventListener('resize', setDeviceType(getDeviceType()));
		return () => window.removeEventListener('resize', setDeviceType(getDeviceType()));
	}, []);

	useEffect(() => {
		document.title = 'Blogs | Home Cooked Food Benefits';
		dispatch(pageAction('Home Cooked Food Benefits'));
	});
	return (
		<>
			<img src={banner} alt='Banner' width='100%' height={deviceType !== "mobile" ? "480" : "200"} />
			<div className='container'>
				<article>
					{deviceType === "mobile" ? <h3>Top 5 Benefits of Eating Home-Cooked Food Daily</h3> : <h2>Top 5 Benefits of Eating Home-Cooked Food Daily</h2>}

					<p>In today`s fast-paced world, where convenience often wins over nutrition, it`s easy to fall into the habit of eating out or relying on packaged meals. But nothing compares to the nourishment and satisfaction that comes from a simple, freshly cooked meal at home.</p>

					<p>At <strong>Shivay Durga Foods</strong>, we believe in the power of homemade food—not just for your body, but for your soul. Here are the top five reasons why choosing home-cooked meals every day is one of the best lifestyle decisions you can make:</p>

					<b>🥦 1. Better Nutrition</b>
					<p>Home-cooked food gives you full control over ingredients, portion sizes, and cooking methods. You avoid unnecessary preservatives, trans fats, and excess sugar that are often found in restaurant or packaged food.</p>
					<p>At <strong>Shivay Durga Foods</strong>, every meal is prepared using <strong>fresh vegetables, whole spices, and traditional recipes</strong>, ensuring you get all the essential nutrients your body needs.</p>

					<b>💪 2. Improved Digestion and Gut Health</b>
					<p>Meals made at home often include more fiber (thanks to fresh vegetables, pulses, and whole grains), less oil, and balanced seasoning. These factors help maintain a healthy digestive system.</p>
					<p>Our tiffins are designed to be <strong>light yet filling</strong>—just like a good home-cooked lunch your mother would pack for you.</p>

					<b>💸 3. Cost-Effective and Budget Friendly</b>
					<p>Ordering food daily from restaurants or delivery apps can become expensive over time. Home-cooked meals are far more economical.</p>
					<p><strong>Shivay Durga Foods</strong> provides healthy, hearty meals at affordable prices, offering excellent value without compromising on quality.</p>

					<b>🫶 4. Emotional and Cultural Connection</b>
					<p>Food isn`t just about sustenance—it`s about comfort, memories, and belonging. Eating traditional dishes like <strong>dal-chawal, roti-sabzi, or sabudana khichdi</strong> reconnects you with your roots.</p>
					<p>At <strong>Shivay Durga</strong>, we take pride in serving meals that remind you of home—especially when you`re living away for studies or work.</p>

					<b>🧼 5. Safer and More Hygienic</b>
					<p>When you eat from unknown sources, you often don`t know the hygiene standards followed. With <strong>Shivay Durga Foods</strong>, every kitchen process is closely monitored:</p>
					<p>
						• Daily kitchen cleaning and sanitization<br />
						• RO-filtered water and clean cooking oil<br />
						• Gloves, head caps, and aprons for kitchen staff
					</p>

					<b>📦 Choose Shivay Durga – Choose Health, Comfort, and Care</b>
					<p>From nutrition to nostalgia, hygiene to heart—<strong>home-style food is always the better choice</strong>. At Shivay Durga Foods, we make sure every meal feels just like home, every day.</p>
				</article>
			</div>
		</>
	);
};
export default HomeCookedFood;
